module.exports = __webpack_public_path__ + "img/hall-of-fame_3.21269600.jpg";